import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments';
import { ApiBaseService } from './api-base.service';
import { PaginationOptions, SearchResult } from '../../common';
import { Hub } from '../abstract/hub.abstract';

@Injectable({
  providedIn: 'root',
})
export class ApiEventsService extends ApiBaseService {
  protected apiBaseUrl: string = environment.campusV2;
  protected routePath = `hubs/${this._hubService.hub()}/events`; // : string;

  constructor(private _hubService: Hub, private _httpClient: HttpClient) {
    super(_httpClient);
  }

  public getEvents(
    paginationOptions: PaginationOptions,
    excludes?: number
  ): Promise<SearchResult[]> {
    let path = `?direction=${paginationOptions.direction}&limit=${paginationOptions.limit}&orderby=${paginationOptions.orderBy}&page=${paginationOptions.page}`;

    if (excludes) {
      path += `&excludes=${excludes}`;
    }

    return super.get<SearchResult[]>(path, {
      headers: this._hubService.hubHeaders(),
    });
  }

  public getEventBySlug(eventSlug: string): Promise<SearchResult> {
    const path = `${eventSlug}`;
    return super.get<SearchResult>(path, {
      headers: this._hubService.hubHeaders(),
    });
  }
}
